import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { Overview } from '#components/Overview/index.tsx';
import { isMovieData, isTvData } from '#helpers/dataTypeGuards.ts';
import { type ComponentProps } from '../types.ts';
import { DetailsOverviewSkeleton } from './DetailsOverviewSkeleton.tsx';

export type DetailsOverviewProps = ComponentProps & {
  disableReadMore?: boolean;
  linesToClamp?: number;
  paragraphSx?: SystemStyleObject<Theme>;
  sx?: SystemStyleObject<Theme>;
};

export const DetailsOverview = ({ data, disableReadMore, linesToClamp, paragraphSx, sx }: DetailsOverviewProps) => {
  if (!data) {
    return <DetailsOverviewSkeleton linesToClamp={linesToClamp} sx={sx} />;
  }

  if (isMovieData(data)) {
    return (
      <Overview
        content={data.movie.overview}
        disableReadMore={disableReadMore}
        id={data.movie.id}
        linesToClamp={linesToClamp}
        name={data.movie.title}
        paragraphSx={paragraphSx}
        sx={sx}
      />
    );
  }

  if (isTvData(data)) {
    return (
      <Overview
        content={data.tv.overview}
        disableReadMore={disableReadMore}
        id={data.tv.id}
        linesToClamp={linesToClamp}
        name={data.tv.name}
        paragraphSx={paragraphSx}
        sx={sx}
      />
    );
  }

  return;
};
